import { render, staticRenderFns } from "./CompanyManager.vue?vue&type=template&id=47440e7e&scoped=true&"
import script from "./CompanyManager.vue?vue&type=script&lang=js&"
export * from "./CompanyManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47440e7e",
  null
  
)

export default component.exports